import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SPECIAL_OFFER_PREVIEW } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'preview-selector',
  templateUrl: './preview-selector.component.html',
  styleUrl: './preview-selector.component.scss',
  standalone: false,
})
export class PreviewSelectorComponent {
  @Input() selectedTab: string;
  @Output() tabChange: EventEmitter<string> = new EventEmitter();
  SPECIAL_OFFER_PREVIEW = SPECIAL_OFFER_PREVIEW;

  tabChangeHandler() {
    this.tabChange.emit(this.selectedTab);
  }
}
